import { v4 as uuid } from "uuid";

import { TCustomerSegment, TLanguage } from "../types";
import { cookieService } from "./cookie/cookie.service";
import { devMode } from "./debug";

export function splitCustomerSegment(customerSegment: TCustomerSegment): {
  segment: string;
  segmentType: string;
} {
  const split = customerSegment.split("-") as [string, string?];
  const isRes = split.length === 1;

  return {
    segment: split[0].toUpperCase(),
    segmentType: isRes
      ? "Person"
      : // capitalize first letter
        split[1]!.charAt(0).toUpperCase() + split[1]!.slice(1),
  };
}

export function defaultOceRequestHeaders(
  useCase: string | null = null,
  lang: TLanguage | null = null,
  customerSegment: TCustomerSegment | null = null,
): Record<string, string> {
  const result: Record<string, string> = {
    "SCS-Request-ID": uuid(),
    "SCS-BusinessTx-ID": uuid(),
    "X-OCE-CLIENT": "shared-header-webcomponent",
  };

  if (useCase) {
    result["X-CLIENT-USECASE"] = useCase;
  }

  if (lang) {
    result.lang = lang;
  }

  if (customerSegment) {
    const { segment, segmentType } = splitCustomerSegment(customerSegment);
    result["X-OCE-CUST-SEGMENT"] = segment;
    result["X-OCE-CUST-TYPE"] = segmentType;
  }

  const xsrf = cookieService.get("OCE-XSRF-TOKEN");
  if (xsrf) {
    result["X-OCE-XSRF-TOKEN"] = xsrf;
  }

  return result;
}

export function stringifyParams(params: Record<string, string> | null) {
  if (!params) {
    return "";
  }
  const result: string[] = [];
  for (const paramKey in params) {
    if (!params[paramKey]) {
      continue;
    }
    result.push(
      `${encodeURIComponent(paramKey)}=${encodeURIComponent(
        params[paramKey]!,
      )}`,
    );
  }

  return result.length ? "?" + result.join("&") : "";
}

export async function fetchWith(
  url: string,
  params: Record<string, string> | null,
  init: RequestInit,
) {
  const response = await fetch(url + stringifyParams(params), init);

  if (response.ok) {
    const body = await response.json();
    return { body, headers: response.headers };
  } else {
    if (devMode) {
      console.error(
        "There has been a problem with your fetch operation!",
        response.statusText,
      );
    }
    throw response;
  }
}
